export default (state, postObj) => {
    state.currentPost = postObj
}
